import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {
  ValidationObserver, ValidationProvider, extend, localize,
} from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
import de from 'vee-validate/dist/locale/de.json';
import fr from 'vee-validate/dist/locale/fr.json';
import it from 'vee-validate/dist/locale/it.json';
import * as rules from 'vee-validate/dist/rules';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueMoment from 'vue-moment';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faPlusCircle,
  faTimesCircle,
  faCheck, faPlus, faMinus,
  faCar,
  faBalanceScale,
  faMoneyBill,
  faSuitcaseRolling,
  faGlobe,
  faRoad,
  faAngleDown,
  faAngleLeft,
} from '@fortawesome/free-solid-svg-icons';
import VueWait from 'vue-wait';
import VueCookies from 'vue-cookies';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import { INSURANCE_MODELS } from '@/support/constants';
import vSelect from 'vue-select';
import ApiService from './services/api.service';

// Translations
import GERMAN from './translations/german';
import ENGLISH from './translations/english';

// Routers
import {
  layoutOneRouter,
} from './router/index';
import store from './store';
import App from './App.vue';

Vue.use(VueWait);
Vue.use(VueI18n);
Vue.use(VueCookies);
Vue.use(VueMoment);

library.add([
  faPlusCircle,
  faTimesCircle,
  faCheck,
  faPlus,
  faMinus,
  faCar,
  faBalanceScale,
  faMoneyBill,
  faSuitcaseRolling,
  faGlobe,
  faRoad,
  faAngleDown,
  faAngleLeft,
]);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('pulse-loader', PulseLoader);

Vue.component('v-select', vSelect);

// install rules and localization
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

const languageInputValue = document.getElementById('broker360-default-language').value;

const selectedLanguage = languageInputValue || window.language;
const languages = {
  en, de, fr, it,
};
localize(selectedLanguage, languages[selectedLanguage]);

// Install components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    goToSpecificStep(stepNumber) {
      this.$store.dispatch('setActiveStep', stepNumber);
    },
    showModelName(modelName) {
      const modelIndex = INSURANCE_MODELS.findIndex((model) => model.code === modelName);
      return INSURANCE_MODELS[modelIndex].label[this.$i18n.locale];
    },
    goToPreviousStep() {
      const stepNumber = this.$store.state.activeStep;
      this.$store.dispatch('setActiveStep', stepNumber - 1);
    },
    filterOffers(offers) {
      return offers.filter(
        (offer) => offer.franchise === this.persons[0].franchise,
      ).filter(
        (offer) => offer.tarifType === this.persons[0].insuranceModel,
      ).filter(
        (offer) => offer.includeAccident === !this.persons[0].accidentCoverage,
      ).sort((a, b) => a.premium - b.premium);
    },
    async getPremiums(person, index) {
      this.$wait.start('Offers');
      const premiumData = [
        {
          key: 13,
          values: [
            person.region.zone,
          ],
        },
        {
          key: 9,
          values: [
            person.region.code.toString(),
          ],
        },
        {
          key: 10,
          values: [
            person.region.zone,
          ],
        },
        {
          key: 14,
          values: [
            person.ageGroup,
          ],
        },
      ];
      await ApiService.post('BasicHealthPremium/GetPremiums', premiumData)
        .then((response) => {
          const offers = response.data;
          this.$store.dispatch('setPersonOffers', { offers, index });
          this.$wait.end('Offers');
        });
    },
    yesNoConverter(value) {
      return value === true ? this.$t('yes') : this.$t('no');
    },
  },
  computed: {
    locale() {
      return selectedLanguage;
    },
    currentYear() {
      return new Date().getFullYear();
    },
  },
});


const pageRouterMapping = {
  layoutOne: layoutOneRouter,
};

ApiService.init(window.broker360ApiAddress || 'https://broker360-health-api.azurewebsites.net/api/');


Vue.use(VueAxios, axios);

const translations = {
  en: ENGLISH,
  de: GERMAN,
};

const i18n = new VueI18n({
  locale: selectedLanguage,
  messages: translations,
});


if (document.getElementById('broker360-pet-app')) {
  new Vue({
    router: pageRouterMapping.layoutOne,
    wait: new VueWait(),
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#broker360-pet-app');
}
